// extracted by mini-css-extract-plugin
module.exports = {"container":"Wrapper_container__1yYrC","titleContainer":"Wrapper_titleContainer__2ZhCw"};